import { render, staticRenderFns } from "./refund.vue?vue&type=template&id=ccecacd4&scoped=true&"
import script from "./refund.vue?vue&type=script&lang=ts&"
export * from "./refund.vue?vue&type=script&lang=ts&"
import style0 from "./refund.vue?vue&type=style&index=0&id=ccecacd4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccecacd4",
  null
  
)

export default component.exports